/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2020
 */
import StaticIdObject from "@shared/StaticIdObject";

export default class DatabaseSettingsItem extends StaticIdObject {

	static CURRENT_DB_VERSION = 19

	dbVersion: number = 0


	constructor() {
		super();
	}
}
